import type {
  Workflow,
  WorkflowBranch,
} from "../../shared/generatedDrizzleSchema";
import { Text } from "./Text";
import { WorkflowBadge } from "./WorkflowBadge";
import { WorkflowSubtext } from "./WorkflowSubtext";

type Props = {
  workflow: Workflow & { branches: readonly WorkflowBranch[] | undefined };
  hover: boolean;
  connectedAppName?: string | null;
};

export function WorkflowNameCell({ workflow, hover, connectedAppName }: Props) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        minWidth: 0,
      }}
    >
      <WorkflowBadge workflow={workflow} hover={hover} />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          minWidth: 0,
        }}
      >
        <Text ellipsis variant="text-regular-md" color="var(--text-primary)">
          {workflow.name}
        </Text>
        <WorkflowSubtext
          workflow={workflow}
          connectedAppName={connectedAppName}
        />
      </div>
    </div>
  );
}
